<div class="profile-preview__section" id="publishing-limit" *ngIf="missionPartner">
  <h2 class="profile-preview__section-title">
    <span nz-icon nzType="file-text" nzTheme="outline"></span>
    {{ "admin.publishing-limit.title" | translate }}
  </h2>
  <div nz-row class="profile-preview__section-content">
    <div nz-col [nzSpan]="24" [nzMd]="6" class="profile-preview__item-label">
      {{ "admin.publishing-limit.current-limit" | translate }}
    </div>
    <div nz-col [nzSpan]="24" [nzMd]="18">
      <div *ngIf="!hasPublisherStatus" class="publishing-limit__no-status-message">
        <strong>{{ "admin.publishing-limit.no-status.title" | translate }}</strong
        ><br />
        {{ "admin.publishing-limit.no-status.message" | translate }}
      </div>
      <div *ngIf="hasPublisherStatus && !isEditing">
        <span class="publishing-limit__value">{{ publishingLimit }}</span>
        <button nz-button nzType="link" nzSize="small" (click)="onEditLimit()" [disabled]="isLoading">
          <span nz-icon nzType="edit" nzTheme="outline"></span>
          {{ "admin.publishing-limit.edit" | translate }}
        </button>
      </div>
      <div *ngIf="hasPublisherStatus && isEditing" class="publishing-limit__edit">
        <nz-input-number
          [(ngModel)]="newLimit"
          [nzMin]="0"
          [nzMax]="999"
          [nzStep]="1"
          [nzPlaceHolder]="'admin.publishing-limit.enter-limit' | translate"
          class="publishing-limit__input"
        ></nz-input-number>
        <button
          nz-button
          nzType="primary"
          nzSize="small"
          (click)="onSaveLimit()"
          [disabled]="isLoading"
          class="publishing-limit__save-btn"
        >
          <span nz-icon nzType="save" nzTheme="outline"></span>
          {{ "admin.publishing-limit.save" | translate }}
        </button>
        <button
          nz-button
          nzType="default"
          nzSize="small"
          (click)="onCancelEdit()"
          [disabled]="isLoading"
          class="publishing-limit__cancel-btn"
        >
          <span nz-icon nzType="close" nzTheme="outline"></span>
          {{ "admin.publishing-limit.cancel" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div nz-row class="profile-preview__section-content">
    <div nz-col [nzSpan]="24">
      <nz-spin *ngIf="isLoading" nzSize="small"></nz-spin>
    </div>
  </div>
</div>
